var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1022_1186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9965 37.9998C8.51201 37.9951 -0.0773694 29.4757 0.000525663 18.8521C0.0772581 8.45634 8.48062 0.0904311 18.8314 -0.000249922C29.4553 -0.0920935 38.1086 8.53423 37.9994 19.202C37.8936 29.5757 29.46 37.9881 18.9965 37.9986V37.9998ZM27.4928 30.0966C27.9451 30.0896 28.4125 29.9826 28.8298 29.7199C30.1099 28.9165 30.6714 26.8448 29.2647 25.4451C27.1836 23.3745 25.1118 21.2947 23.0354 19.2183C22.8889 19.0718 22.8897 18.9246 23.0377 18.7765C25.1083 16.706 27.1789 14.6354 29.2495 12.5637C30.0703 11.7429 30.3226 10.5281 29.889 9.49452C29.4914 8.54702 28.4311 7.88202 27.3312 7.9076C26.5674 7.92504 25.9361 8.24242 25.3978 8.78186C23.3528 10.835 21.3008 12.8811 19.2522 14.9307C19.0833 15.0997 18.9139 15.0985 18.7442 14.9272C16.6956 12.8776 14.6471 10.828 12.5963 8.7807C11.6453 7.83087 10.2048 7.62044 9.16889 8.27498C7.89002 9.08297 7.32964 11.1524 8.73524 12.5509C10.8163 14.6215 12.8881 16.7013 14.9645 18.7777C15.111 18.9242 15.1102 19.0714 14.9622 19.2195C12.8974 21.2854 10.8303 23.349 8.76779 25.416C7.92722 26.2589 7.6761 27.461 8.11207 28.5003C8.51085 29.4478 9.56999 30.1117 10.6698 30.0873C11.4348 30.071 12.065 29.7501 12.6021 29.2118C14.6483 27.1599 16.6991 25.1126 18.7477 23.0641C18.9166 22.8952 19.086 22.8963 19.2557 23.0676C21.3042 25.1172 23.3551 27.1634 25.4013 29.2153C25.9698 29.785 26.6488 30.0803 27.4917 30.0954L27.4928 30.0966Z",
    fill: "#FF1E26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1022_1186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.3085142c7a1fc78e85801dbc8d90a8d1.svg";
export { ForwardRef as ReactComponent };